<template>
    <section class="py-4 border-bottom">
        <div class="row">
            <div class="col-lg-6">
                <span class="regular-title mr-1">{{$t('components.ConfiguratorResumePackage.packaging')}}</span>
                <br/>
                <div class="note-beta">{{$t('components.ConfiguratorResumePackage.forAllGoods')}}</div>
            </div>

            <div class="col-lg-5 text-right">
                <div class="priceAction">
                    <div class="priceAction__after">{{$t('components.ConfiguratorResumePackage.forFree')}}</div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {}
</script>